import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.DisconnectedAlert', {
    title: 'Your Organisation is disconnected',
    noBudgetsTitle: 'You don’t see any Budgets because your Organisation is disconnected from {integrationName}',
    inlineTitle:
        'Your Organisation is disconnected, please reconnect to your {integrationName} account to upload the budget',
    subtitle: 'Please reconnect to your {integrationName} account to upload the budget',
    readOnlyMode: 'The organisation trial expired. All data is available in read-only mode.',
    reconnect: 'Reconnect now',
});
